jQuery( document ).ready(function() {
    if( jQuery('section.contact-us').length ) {

        function matchStart(params, data) {
            params.term = params.term || '';
            if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) == 0) {
                return data;
            }
            return false;
        }

        // Select2 with search
        jQuery('.select2-search').select2({
            matcher: function(params, data) {
                return matchStart(params, data);
            },
        });

        // Select2 without search
        jQuery('.select2-no-search').select2({
            minimumResultsForSearch: Infinity
        });

        // Contact form parameters | Looking for
        if( getUrlParameter('looking-for') != false ) {
            jQuery('select[name=looking-for]').val(getUrlParameter('looking-for'));
            jQuery('select[name=looking-for]').trigger('change');
        }
    }
});

// Get parameters from URL
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};